import React from 'react'
import './index.css'
import RifterList from './components/RifterList'
import BackToTop from './components/BackToTop'

function App () {
  return (
    <div className='App'>
      <a href='#main-content' className='skip-link'>
        Skip to main content
      </a>
      <header className='App-header'>
        <div className='header-content'>
          <div className='header-text'>
            <h1>The Rifter® Index</h1>
            <p>Search through The Rifter® magazine archives</p>
          </div>
        </div>
      </header>
      <main id='main-content' className='App-main'>
        <RifterList />
      </main>
      <footer>
        <p>
          © 2026 <a href='https://www.dpenwood.com' target='_blank' rel='noopener noreferrer'>D. Penwood</a>. The Rifter®
          is a registered trademark of Palladium Books® Inc. Non-commercial use
          only.
        </p>
      </footer>
      <BackToTop />
    </div>
  )
}

export default App
